/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsUserRole
 */
export interface ControlcenterMelcoModelsUserRole {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserRole
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserRole
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsUserRole
     */
    name?: string | null;
}

export function ControlcenterMelcoModelsUserRoleFromJSON(json: any): ControlcenterMelcoModelsUserRole {
    return ControlcenterMelcoModelsUserRoleFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsUserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsUserRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ControlcenterMelcoModelsUserRoleToJSON(value?: ControlcenterMelcoModelsUserRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
    };
}


